// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// To update icon packs, go to https://uifabricicons.azurewebsites.net/ and select the subset of icons needed
// This will give you a zip file with some typescript files
// If you strip out things that are not needed and fix up according to our formatting rules, you should end up with something like this,
// which looks an awful lot like https://github.com/OfficeDev/office-ui-fabric-react/blob/master/packages/icons/src/fabric-icons.ts

import {
  FabricDependencies,
  IIconOptions,
  IIconSubset,
} from './fabric-dependencies'

const DEFAULT_BASE_URL =
  'https://static2.sharepointonline.com/files/fabric/assets/icons/'

export const initializeIcons = (
  { registerIcons }: FabricDependencies,
  baseUrl = DEFAULT_BASE_URL,
  options?: IIconOptions
) => {
  const subset: IIconSubset = {
    fontFace: {
      fontFamily: `"FabricMDL2Icons"`,
      src: `url('${baseUrl}fabric-icons-a13498cf.woff') format('woff')`,
    },
    icons: {
      Cancel: '\uE711',
    },
    style: {
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      fontStyle: 'normal',
      fontWeight: 'normal',
      speak: 'none',
    },
  }

  registerIcons(subset, options)
}
